import dynamic from 'next/dynamic'

import Image from 'components/Image'
import Link from 'components/Link'
import { getOptimizedImageUrl } from 'lib/image'

import Styled from './styled'

const Carousel = dynamic(() => import('components/Carousel'))

export default function SectionBanner({ banners }) {
  const coverImages = banners || []

  const renderBanner = item => {
    const image = item?.bannerImage?.[0]?.url
    const imageAlt = item?.bannerImage?.[0]?.alternativeText || item?.title || '24 FIX'
    const mobileImage = item?.mobileImage?.[0]?.url
    const url = item?.redirectUrl || '/'

    return (
      <Link href={url} openNewTab>
        <div className={`image ${mobileImage ? 'has-mobile-image' : ''}`}>
          <picture>
            {mobileImage && (
              <source media="(max-width: 768px)" srcSet={getOptimizedImageUrl(mobileImage, 750)} />
            )}
            <source media="(min-width: 769px)" srcSet={getOptimizedImageUrl(image, 1920)} />
            <Image
              src={image}
              alt={imageAlt}
              imgixWidth={750}
              lazyload={false}
              fetchpriority="high"
            />
          </picture>
        </div>
      </Link>
    )
  }

  return (
    <Styled>
      <div className="banner-image-block">
        {coverImages.length <= 1 ? (
          coverImages[0] ? (
            renderBanner(coverImages[0])
          ) : null
        ) : (
          <Carousel
            options={{
              autoplay: {
                delay: 8000,
              },
            }}
            items={coverImages}
            uiRenderer={renderBanner}
          />
        )}
      </div>
    </Styled>
  )
}
